<template>
	<div>
		<productCenNav ref="productCenNav" :list="navList" @goScroll="goScroll" v-show="cenNavHidden"></productCenNav>
		<template v-for="(item,index) in navList">
			<component :is="mapComponent[item.value]" :list='item' :ref="item.value+'a'+index" @goScroll='event=>goScroll(event,index)' />
		</template>
	</div>
</template>

<script>
	import productCenNav from "./productCenNav"
	import mapComponent from "@/components/mapComponentTwo.js";
	export default {
		components: {
			productCenNav,
		},
		data() {
			return {
				mapComponent,
				navList: [
					
				],
				navHidden: false,
				scrollTop: 0,
				scrollTopNav: 0,
				cenNavHidden: true,
				navTop:[],
				querValue:'',
				info:''
			}
		},
		watch: {
			scrollTop() {
				if (this.scrollTop < this.scrollTopNav) {
					this.cenNavHidden = true;
				}
				this.navList.map((v,a)=>{
					if(!v.name){
						return;
					}
					if(a+1==this.navList.length){
						if ((this.scrollTop+70) > this.navTop[a]) {
							this.$refs.productCenNav.current=a;
						}
					}else{
						if ((this.scrollTop+70) > this.navTop[a]&&(this.scrollTop+70)< this.navTop[a+1]) {
							this.$refs.productCenNav.current=a;
						}
					}
				})
			},
			querValue(){
				let t=this;
				console.log(this.querValue,"aaaaaaaaaaaaaaaaaaaa")
				this.$nextTick(function(){
					t.setTop();
				})
			},
			navList(){
				let t=this;
				
				this.$nextTick(function(){
					var element;
					if(this.nowVibe=='pc'){
						element= document.documentElement
					}else{
						element = document.documentElement.scrollTop ? document.documentElement : document.body;
					}
					t.scrollTop = element.scrollTop;
					t.setTop();
					t.getTop();
				})
			},
			navTop(){
				if (this.scrollTop < this.scrollTopNav) {
					this.cenNavHidden = true;
				}
				this.navList.map((v,a)=>{
					if(!v.name){
						return;
					}
					if(a+1==this.navList.length){
						if ((this.scrollTop+70) > this.navTop[a]) {
							this.$refs.productCenNav.current=a;
						}
					}else{
						if ((this.scrollTop+70) > this.navTop[a]&&(this.scrollTop+70)< this.navTop[a+1]) {
							this.$refs.productCenNav.current=a;
						}
					}
				})
			}
		},
		mounted() {
			let t=this;
			let offsetTop = this.$refs.productCenNav.$el.offsetTop;
			this.scrollTopNav = offsetTop;
			window.addEventListener('scroll', this.handleScroll);
			this.querValue=this.$route.query.value;
			// t.setList();
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			setTop(){
				this.navList.map((v,a)=>{
					if(!v.name){
						return;
					}
					if(this.querValue==v.value){
						this.$refs.productCenNav.current=a;
						this.goScroll(this.querValue,a)
					}
				})
			},
			getTop(){
				let top=[];
				this.navList.map((v,a)=>{
					console.log('-----开始-----')
					console.log(v.value+'a'+a)
					console.log(this.$refs[v.value+'a'+a])
					console.log(this.$refs[v.value+'a'+a][0])
					console.log(this.$refs[v.value+'a'+a][0].$el.offsetTop)
					let stop=this.$refs[v.value+'a'+a][0].$el.offsetTop
					top.push(stop-100)
					console.log('-----结束-----')
				})
				this.$nextTick(function() {
					this.navTop = top;
					console.log(this.navTop,"107啊啊啊啊啊啊啊啊啊啊啊啊")
				})
			},
			goScroll(e,index) {
				console.log(e+'a'+index,this.$refs[e+'a'+index])
				let offsetTop = this.$refs[e+'a'+index][0].$el.offsetTop - 70;
				this.$emit('goScroll',offsetTop)
				// document.documentElement.scrollTop = offsetTop+10;
			},
			handleScroll(e) {
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				this.scrollTop = element.scrollTop;
			},
			setInfo(e){
				this.info=e;
				let list=e.modules;
				list.forEach((v,a)=>{
					if(v.data&&v.data.menuName){
						v.name=v.data.menuName
					}else{
						v.name=''
					}
					v.value=v.code;
					if(a<list.length-1){
						if(v.value==list[a+1].code){
							list[a+1].top=0
						}
					}
				})
				// let listTwo=[
				// 	{
				// 		name: '',
				// 		value: 'data86',
				// 		top:0
				// 	},
				// ]
				this.$nextTick(function(){
					// this.navList=[...list,...listTwo];
					this.navList=list;
					this.$refs.productCenNav.setList(this.navList)
				})
			},
			setList(){
				let t=this;
				let id = this.$route.query.id;
				let arr=[]
				// 周边产品
				if(Number(id)==1){
					 arr=[
						{
							name: this.$t('畅享高效诊疗体验'),
							value: 'data1',
						},
						{
							name: this.$t('解锁更多应用场景'),
							value: 'data2',
						},
						{
							name: this.$t('高分辨率画质'),
							value: 'data3',
						},
						{
							name: this.$t('诊疗操作优势'),
							value: 'data4',
						},
						{
							name: this.$t('临床应用'),
							value: 'null',
						},
					];
				};
				if(Number(id)==2){
					 arr=[
						{
							name: this.$t('100倍放大'),
							value: 'data5',
						},
						{
							name: this.$t('超高精度'),
							value: 'data6',
						},
						{
							name: this.$t('人性化设计'),
							value: 'data7',
						},
					];
				};
				if(Number(id)==3){
					 arr=[
						{
							name: this.$t('体验焕新'),
							value: 'data8',
						},
						{
							name: this.$t('临床应用'),
							value: 'data9',
						},
						{
							name: this.$t('配套产品'),
							value: 'data10',
						},
					];
				};
				if(Number(id)==4){
					 arr=[
						{
							name: this.$t('超高分辨率成像'),
							value: 'data11',
						},
						{
							name: this.$t('全新5代手柄'),
							value: 'data12',
						},
					];
				};
				if(Number(id)==5){
					 arr=[
						{
							name: this.$t('多功能集成'),
							value: 'data13',
						},
						{
							name: this.$t('结肠镜升级'),
							value: 'data14',
						},
						{
							name: this.$t('临床应用'),
							value: 'data15',
						},
					];
				};
				// 内镜系统
				if(Number(id)==6){
					 arr=[
						{
							name: this.$t('配套产品'),
							value: 'data16',
							valueTwo: 'data85',
						},
						{
							name: this.$t('高灵敏度'),
							value: 'data17',
						},
						{
							name: this.$t('创新标杆'),
							value: 'data18',
						},
						{
							name: this.$t('轻量手柄'),
							value: 'data19',
						},
						{
							name: this.$t('一体防水'),
							value: 'null',
						},
						{
							name: this.$t('功能齐全'),
							value: 'data20',
						},
					];
				};
				if(Number(id)==7){
					 arr=[
						{
							name: this.$t('临床应用'),
							value: 'data21',
						},
						{
							name: this.$t('配套产品'),
							value: 'data22',
						},
						{
							name: this.$t('高画质'),
							value: 'data23',
						},
						{
							name: this.$t('轻量手柄'),
							value: 'data24',
						},
						{
							name: this.$t('完备诊疗'),
							value: 'data25',
						},
						{
							name: this.$t('配套产品'),
							value: 'null',
						},
						{
							name: this.$t('高清画质'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==8){
					 arr=[
						{
							name: this.$t('轻量手柄'),
							value: 'data27',
						},
						{
							name: this.$t('头端LED光源'),
							value: 'data28',
						},
						{
							name: this.$t('一体防水'),
							value: 'data29',
						},
						{
							name: this.$t('便捷诊疗'),
							value: 'data30',
						},
						{
							name: this.$t('配套产品'),
							value: 'data31',
						},
						{
							name: this.$t('画面真实自然'),
							value: 'data32',
						},
						{
							name: this.$t('手柄轻量体验'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==9){
					 arr=[
						{
							name: this.$t('先端部弯曲灵活'),
							value: 'data33',
						},
						{
							name: this.$t('操作自如便捷'),
							value: 'data34',
						},
						{
							name: this.$t('配套产品'),
							value: 'data35',
						},
						{
							name: this.$t('画面更清晰'),
							value: 'data36',
						},
						{
							name: this.$t('连接更简单'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==10){
					 arr=[
						{
							name: this.$t('先端部半径更小'),
							value: 'data28',
						},
						{
							name: this.$t('操控更顺畅'),
							value: 'data34',
						},
						{
							name: this.$t('配套产品'),
							value: 'data35',
						},
						{
							name: this.$t('高像素'),
							value: 'data32',
						},
						{
							name: this.$t('CBI分光染色'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==11){
					 arr=[
						 {
						 	name: this.$t('超细插入部'),
						 	value: 'data28',
						 },
						{
							name: this.$t('优势特点'),
							value: 'data28',
						},
						{
							name: this.$t('临床应用'),
							value: 'data34',
						},
						{
							name: this.$t('配套产品'),
							value: 'data35',
						},
						{
							name: this.$t('高像素'),
							value: 'data26',
						},
					];
				};
				
				if(Number(id)==12){
					 arr=[
						 {
						 	name: this.$t('CBI分光染色'),
						 	value: 'data37',
						 },
						{
							name: this.$t('大钳道'),
							value: 'data38',
						},
						{
							name: this.$t('纤细迭代'),
							value: 'data39',
						},
						{
							name: this.$t('优势特点'),
							value: 'data40',
						},
						{
							name: this.$t('临床应用'),
							value: 'data41',
						},
					];
				};
				// 电子内镜
				if(Number(id)==13){
					 arr=[
						 {
						 	name: this.$t('配套产品'),
						 	value: 'data42',
						 },
						{
							name: this.$t('清晰图像'),
							value: 'data43',
						},
						{
							name: this.$t('高效洗消'),
							value: 'data44',
						},
						{
							name: this.$t('安全牢固'),
							value: 'data45',
						},
						{
							name: this.$t('便于临床'),
							value: 'data41',
						},
						{
							name: this.$t('临床应用'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==14){
					 arr=[
						 {
						 	name: this.$t('配套产品'),
						 	value: 'data46',
						 },
						{
							name: this.$t('内镜医师的得力助手啊啊'),
							value: 'data47',
						},
						{
							name: this.$t('内镜操作规范化'),
							value: 'data48',
						},
						{
							name: this.$t('内镜诊疗高效化'),
							value: 'data49',
						},
						{
							name: this.$t('质控分析平台化'),
							value: 'data41',
						},
						{
							name: this.$t('配套产品'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==15){
					 arr=[
						 {
						 	name: this.$t('操作简易'),
						 	value: 'data50',
						 },
						{
							name: this.$t('便于诊疗'),
							value: 'data51',
						},
						{
							name: this.$t('精巧设计'),
							value: 'data52',
						},
						{
							name: this.$t('智能化'),
							value: 'data53',
						},
						{
							name: this.$t('便捷化'),
							value: 'data54',
						},
						{
							name: this.$t('轻量化'),
							value: 'data41',
						},
						{
							name: this.$t('高效测漏'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==16){
					 arr=[
						 {
						 	name: this.$t('巧思设计'),
						 	value: 'data55',
						 },
						{
							name: this.$t('可调节'),
							value: 'data56',
						},
						{
							name: this.$t('可通电'),
							value: 'data57',
						},
						{
							name: this.$t('可拓展'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==17){
					 arr=[
						 {
						 	name: this.$t('超高清'),
						 	value: 'data58',
						 },
						{
							name: this.$t('CBI分光染色'),
							value: 'data59',
						},
						{
							name: this.$t('交互新体验'),
							value: 'data60',
						},
						{
							name: this.$t('人性化设计'),
							value: 'data61',
						},
						{
							name: this.$t('临床应用'),
							value: 'data62',
						},
						{
							name: this.$t('配套产品'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==18){
					 arr=[
						 {
						 	name: this.$t('CBI 染色升级'),
						 	value: 'data63',
						 },
						{
							name: this.$t('百万像素'),
							value: 'data64',
						},
						{
							name: this.$t('新兴技术'),
							value: 'data65',
						},
						{
							name: this.$t('高效平台'),
							value: 'data66',
						},
						{
							name: this.$t('出色操控'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==19){
					 arr=[
						 {
						 	name: this.$t('临床应用'),
						 	value: 'data67',
						 },
						{
							name: this.$t('配套产品'),
							value: 'data68',
						},
						{
							name: this.$t('CBI 染色'),
							value: 'data69',
						},
						{
							name: this.$t('高画质'),
							value: 'data70',
						},
						{
							name: this.$t('图像处理'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==20){
					 arr=[
						 {
						 	name: this.$t('功能应用'),
						 	value: 'data71',
						 },
						{
							name: this.$t('光源可选'),
							value: 'data72',
						},
						{
							name: this.$t('高兼容性'),
							value: 'data73',
						},
						{
							name: this.$t('配套产品'),
							value: 'data74',
						},
						{
							name: this.$t('多场景运用'),
							value: 'data75',
						},
						{
							name: this.$t('高效内镜平台'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==21){
					 arr=[
						 {
						 	name: this.$t('功能强大'),
						 	value: 'data76',
						 },
						{
							name: this.$t('头端LED光源'),
							value: 'data77',
						},
						{
							name: this.$t('配套产品'),
							value: 'data78',
						},
						{
							name: this.$t('清晰画质'),
							value: 'data79',
						},
						{
							name: this.$t('功能强大'),
							value: 'data80',
						},
						{
							name: this.$t('LED光源高续航'),
							value: 'data75',
						},
						{
							name: this.$t('高兼容性'),
							value: 'data26',
						},
					];
				};
				if(Number(id)==22){
					 arr=[
						 {
						 	name: this.$t('配套产品'),
						 	value: 'data81',
						 },
						{
							name: this.$t('一体化设计'),
							value: 'data82',
						},
						{
							name: this.$t('高画质'),
							value: 'data83',
						},
						{
							name: this.$t('功能强大'),
							value: 'data84',
						},
						{
							name: this.$t('LED光源高续航'),
							value: 'data75',
						},
						{
							name: this.$t('配套产品'),
							value: 'data26',
						},
					];
				};
				this.navList=arr;
				// this.$nextTick(function(){
				// 	t.scrollTop = document.documentElement.scrollTop;
				// 	t.getTop();
				// })
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">

</style>